import { OrganizationModel } from '../models/organization.model';
import { CollectionModel } from 'src/app/organizations/models/collection.model';
import { BookmarkGroupModel } from 'src/app/bookmarks/models/bookmark.group.model';
import { WidgetOptions } from 'src/app/publish/models/widget-options.model';

export class OrganizationsStateModel {
   
    organizations?: OrganizationModel[];
    organization?: OrganizationModel;
    collections?: CollectionModel[];

    selectedOrganization?: OrganizationModel;
    selectedCollection?: CollectionModel;

    widgetURL?: string;
    widgetOptions?: WidgetOptions;

    appFeatures?: {
        offlinePkgGen?: boolean;
    };
}
